import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api"
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 402 && error.response?.data?.subscription_locked) {
      const msg = encodeURIComponent(error.response.data.message || "Subscription expired");
      if (!window.location.pathname.startsWith("/subscription-locked")) {
        window.location.href = `/subscription-locked?msg=${msg}`;
      }
    }
    return Promise.reject(error);
  }
);

export default instance;